var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"14","height":"9","viewBox":"0 0 14 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.5 1L6 5.5L1.5 1","stroke":_vm.getAssets.primaryBrandColor || '#000000',"stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }